<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M3 3v18h18" />
  <path d="m7 14 4-4 3 3 5-6" />
</svg></template>

<script>
export default {}
</script>